import { render, staticRenderFns } from "./CCDisabledIcon.vue?vue&type=template&id=6b3a1e9d&"
import script from "./CCDisabledIcon.vue?vue&type=script&lang=js&"
export * from "./CCDisabledIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports